
import { Store } from '@package/redux';
import { middleware as requestMiddleware } from "@package/request";
import { name as dialogReducerName, reducer as dialogReducer } from '@package/dialog';
import { name as notificationsReducerName, reducer as notificationsReducer } from '@package/notifications';
import { name as buttonWidgetReducerName, reducer as buttonWidgetReducer } from '@widget/functional-button';
import { name as profileWidgetReducerName, reducer as profileWidgetReducer } from '@widget/profile';
import { name as messagesWidgetReducerName, reducer as messagesWidgetReducer } from '@widget/notification';

import { reducer as formReducer } from 'redux-form';


export function create(reducers) {

  const redux = new Store({
    reducers: {
      'form': formReducer,
      [dialogReducerName]: dialogReducer,
      [buttonWidgetReducerName]: buttonWidgetReducer,
      [notificationsReducerName]: notificationsReducer,
      [profileWidgetReducerName]: profileWidgetReducer,
      [messagesWidgetReducerName]: messagesWidgetReducer,
      ...reducers,
    },
    middleware: [
      requestMiddleware({
        silent: true,
        host: window.env['API_HOST'],
      }),
    ]
  });

  redux.create();

  return redux;
}

export async function getReducersFromRoutes(routes) {
  const reducers = {};
  for (let index in routes) {
    if (routes.hasOwnProperty(index)) {
      const route = routes[index];
      const module = await route['module'];
      if (('name' in module) && ('reducer' in module)) {
        reducers[module['name']] = module['reducer'];
      }
    }
  }
  return reducers;
}
